<template>
  <TinymceEditor ref="tinymceEditor" :value="value" :init="init" v-bind="$attrs" v-on="$listeners"></TinymceEditor>
</template>
<script>
import TinymceEditor from '../../basis/tinymce-editor/index.vue'
import Api from './api.js'
import response from '../../../utils/response'
import { componentMessage } from '../utils'
export default {
  name: 'sy-tinymce-editor-extend',
  components: {TinymceEditor},
  props: {
    // 绑定的数据
    value: {
      type: String,
      default: ''
    },
    // 自定义配置
    init: {
      type: Object,
      default: () => { 
        return {
          content_style: '',
          font_formats: ''
        } 
      }
    }
  },
  data () {
    return {
      componentMessage
    }
  },
  created () {
    this.componentMessage(['mall', 'purchaser', 'supplier'], 'tinymce-editor')
    this.getEnableFontConfig()
  },
  methods: {
    getCoreEditor () {
      return this.$refs['tinymceEditor'].getCoreEditor()
    },
    // 是否开启字体配置
    async getEnableFontConfig () {
      const api = Api.isEnableFontConfig
      const res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        const isEnable = res.content === '0'
        isEnable && this.getFontConfigStructure()
      }
    },
    // 获取字体配置规则
    async getFontConfigStructure () {
      const api = Api.fontConfigStructure
      const res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        const data = res.content || {}
        const config = JSON.parse(data)
        const fontConfigArr = config?.options?.font_config_structure || []
        // const fontStyle = `
        //   @font-face{
        //     font-family: "PorscheNextTT";
        //     src: url("https://sunyur-test-isolation-img.oss-cn-zhangjiakou.aliyuncs.com/2c7ccfa1df309280/publicFont/PorscheNextTT-Regular.woff") format("woff");
        // }`
        let fontStyle = ''
        let fontFamily = ''
        fontConfigArr.forEach(item => {
          fontFamily += `${item.fontFamily}; `
          fontStyle += `
            @font-face{
              font-family:"${item.fontFamily}";
              src: url("${item.woffUrl}") format("woff"), url("${item.ttfUrl}") format('truetype');
            }`
        })
        this.$set(this.init, 'content_style', fontStyle + this.init?.content_style)
        this.$set(this.init, 'font_formats', fontFamily + this.init?.content_style)
      }
    }
  }
}
</script>